export default __webpack_public_path__ + "static/media/endorse.0cf8a021.png";